import React, { useRef } from 'react'
import SymbolSelectManager, {
  ISymbolSelectManagerRef,
} from '../../common/components/dialogs/symbolSelectDialog/SymbolSelectManager'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { useApplicationSuiteContext } from '../../contexts/ApplicationSuiteProvider'
import { ISymbol } from '../../common/components/dialogs/symbolSelectDialog/SymbolSelect'

type SymbolSelectProps = {
  symbol: string | undefined
  onSelect: (symbol: ISymbol | undefined) => void
  disabled?: boolean
}

function SymbolSelect({ symbol, onSelect, disabled = false }: SymbolSelectProps) {
  const { symbols } = useApplicationSuiteContext()

  const managerRef = useRef<ISymbolSelectManagerRef | null>(null)
  const openSymbolSelectDialog = () => {
    if (disabled) return
    if (managerRef.current) {
      // @ts-ignore
      managerRef.current.openDialog()
    }
  }

  return (
    <>
      <SymbolSelectManager
        ref={managerRef}
        caller={'symbolSelect'}
        symbolSelectCallback={onSelect}
        symbols={(symbols || []) as ISymbol[]}
        currentSymbol={symbol}
      />
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="symbol">Symbol</InputLabel>
        <Select
          labelId="symbol"
          value={symbol}
          name="executionSymbol"
          label="Symbol"
          open={false}
          onClick={openSymbolSelectDialog}
          disabled={disabled}
        >
          {(symbols || []).map((symbol: any, index) => (
            <MenuItem key={index} value={symbol.name}>
              {symbol.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  )
}

export default SymbolSelect
